export const DOCUMENT_TYPES = {
  WARRANT: 'WARRANT',
  WARRANT_ATTACHMENT: 'WARRANT_ATTACHMENT',
  SIGNATURE: 'SIGNATURE',
  BALANCE_LIST: 'BALANCE_LIST',
  FINAL_PACKAGE: 'FINAL_PACKAGE',
  REJECTION: 'REJECTION',
  REMINDER: 'REMINDER',
  DEATH_CERTIFICATE: 'DEATH_CERTIFICATE',
  HISTORY: 'HISTORY',
};

export const ARCHIVING_MAP = {
  NEW_BANK: [
    DOCUMENT_TYPES.DEATH_CERTIFICATE,
    DOCUMENT_TYPES.HISTORY,
    DOCUMENT_TYPES.WARRANT_ATTACHMENT,
    DOCUMENT_TYPES.SIGNATURE,
    DOCUMENT_TYPES.REJECTION,
    DOCUMENT_TYPES.WARRANT,
    DOCUMENT_TYPES.REMINDER,
    DOCUMENT_TYPES.BALANCE_LIST,
    DOCUMENT_TYPES.FINAL_PACKAGE,
  ],
  OLD_BANK: [
    DOCUMENT_TYPES.REJECTION,
    DOCUMENT_TYPES.WARRANT,
    DOCUMENT_TYPES.BALANCE_LIST,
    DOCUMENT_TYPES.REMINDER,
    DOCUMENT_TYPES.HISTORY,
  ],
};
